import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import { setRoomUnreadState, clearRoomJustOpened } from '../actions/room';
import { getInitialUnreadRoomState } from '../helpers/roomState';
import {
  updateRoomUnreadState,
  markLastViewedMessageSuccess,
} from '../actions/roomUnread';

export default handleActions<DamzState['roomUnreadState'], any>(
  {
    [`${setRoomUnreadState}`]: (
      state,
      action: ReturnType<typeof setRoomUnreadState>
    ) => {
      return {
        ...state,
        [action.payload.room_id]: {
          ...getInitialUnreadRoomState(state, action.payload.room_id),
          lastViewedMessageId: action.payload.lastViewMessageId,
          unreadMessageCount: action.payload.unreadMessageCount,
        },
      };
    },
    [`${updateRoomUnreadState}`]: (
      state,
      action: ReturnType<typeof updateRoomUnreadState>
    ) => {
      const currentState = state[action.payload.room_id];
      if (!currentState) {
        return state;
      }

      return {
        ...state,
        [action.payload.room_id]: {
          ...currentState,
          ...action.payload.updates,
        },
      };
    },
    [`${clearRoomJustOpened}`]: (
      state,
      action: ReturnType<typeof clearRoomJustOpened>
    ) => {
      const currentState = state[action.payload.room_id];
      if (!currentState) {
        return state;
      }

      return {
        ...state,
        [action.payload.room_id]: {
          ...currentState,
          isJustOpened: false,
        },
      };
    },
    [`${markLastViewedMessageSuccess}`]: (
      state,
      action: ReturnType<typeof markLastViewedMessageSuccess>
    ) => {
      const currentState = state[action.payload.room_id];
      if (!currentState) {
        return state;
      }

      return {
        ...state,
        [action.payload.room_id]: {
          ...currentState,
          lastMarkedMessageId: action.payload.messageId,
        },
      };
    },
  },
  {}
);
